export const config = {
  cookieName: "cookie_info",
  cookieDismissedValue: "dismissed",
  dismissalDays: 365
};
